import { useStore } from "stook";

interface IRescueAddress {
  acdtProvince: string; //救援省份,
  provinceAdcode: string;
  acdtCity: string; //救援市
  cityAdcode: string;
  acdtDistrict: string; //救援县
  districtAdcode: string;
  acdtAddress: string; //救援详细地址
  longitude: number;
  latitude: number;
}
let INIT_ADDRESS_DATA = {
  acdtProvince: "",
  provinceAdcode: "",
  acdtCity: "",
  cityAdcode: "",
  acdtDistrict: "",
  districtAdcode: "",
  acdtAddress: "",
  longitude: 0,
  latitude: 0,
};

if (process.env.REACT_APP_DELOY_ENV === "test") {
  INIT_ADDRESS_DATA = {
    acdtProvince: "广东省",
    provinceAdcode: "440000",
    acdtCity: "广州市",
    cityAdcode: "020",
    acdtDistrict: "天河区",
    districtAdcode: "440106",
    acdtAddress: "长兴街道岑村丰庄大街10号广州小鹏科技园",
    longitude: 113.385925,
    latitude: 23.153875,
  };
}

export default function useRescueAddressHook() {
  const [rescueAddress, setRescueAddress] = useStore<IRescueAddress>(
    "RescueAddress",
    INIT_ADDRESS_DATA,
  );

  const resetAddressInfo = () => {
    setRescueAddress(INIT_ADDRESS_DATA);
  };

  return {
    rescueAddress,
    setRescueAddress,
    resetAddressInfo,
  };
}
